import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import authReducer from './slices/auth'
import usersReducer from './slices/users'
import adminsReducer from './slices/admins'
import stateReducer from './slices/state'

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: 'redux',
  storage,
  keyPrefix: '',
  whitelist: ['auth', 'users', 'admins', 'state'],
};

const rootReducer = combineReducers({
  auth: authReducer,
  users: usersReducer,
  admins: adminsReducer,
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  product: productReducer,
  state: stateReducer
});

export default rootReducer;
